export default __webpack_public_path__ + "i18n/translation-tr.2c82b8c3.json";